import WebResultsTemplate from './web-results.html';

class WebResults {
    constructor(StatsService, $log) {
        'ngInject';
        
        this.$log = $log;
        this.statsService = new StatsService();
        /*
        this.tags = {
            'Web': {
                name: 'Web',
                regex: /home.www.uprr.com/i
            },
            'UPOnline': {
                name: 'UPOnline',
                regex: /UPOnline/i
            },
            'UP': {
                name: 'UP',
                regex: /www.up.com/i
            },
            'ITNews': {
                name: 'ITNews',
                regex: /ITNews/i
            }
        };
        */
    }
    
    loadMoreResults() {
        this.onLoadMoreResults();
    }
    
    postActivityStatistic(url, position) {
        this.statsService.postActivityStatistic(this.searchTerm, this.searchTermToSearch, url, position + 1).catch((message) => {
            this.$log.error("Could not post activity statistic: " + message);
        });
    }
    
    /*
    checkTag(tag, site, newsType) {
        console.log(site);
        console.log(tag.regex);
        console.log(tag.regex.test(site));
        if (tag.regex.test(site)) {
            return true;
        }
        else if (tag.regex.test(newsType)) {
            return true;
        }
        return false;
    }
    */
}

export default {
  bindings: {
      results: '<',
      loading: '<',
      infiniteScrollDisabled: '<',
      searchTerm: '<',
      searchTermToSearch: '<',
      onLoadMoreResults: '&'
  },
  controller: WebResults,
  template: WebResultsTemplate
};



// WEBPACK FOOTER //
// ./src/search-interface/shared/components/web-results/web-results.js